<template>
  <v-layout column>
    <v-layout v-if="totalItems" class="pa-4" column>
      <v-card
        class="application-item mb-4"
        v-for="(payment_slip, index) in payment_slips"
        :key="index"
      >
        <v-toolbar color="teal darken-4" dark>
          <v-toolbar-side-icon left>{{payment_slip.application_type.acronym}}</v-toolbar-side-icon>
          <v-toolbar-title>Boleto: {{payment_slip.application_type.name}}</v-toolbar-title>
          <v-spacer />
          <span
            class="mr-3"
            v-if="!!payment_slip.processing_number"
          >
            Número: {{payment_slip.processing_number}}
          </span>
        </v-toolbar>

        <v-list two-line subheader>
          <v-list-tile avatar @click="showApplication(payment_slip)">
            <v-list-tile-avatar>
              <v-icon>{{ personalTypeIcon(payment_slip) }}</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>{{payment_slip.person.name}}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action v-if="payment_slip.last_viewed_at">
              <v-tooltip left>
                <v-list-tile-action-text class="badge blue" slot="activator">
                  Visualizado
                </v-list-tile-action-text>
                <v-list-tile-action-text class="badge deep-orange" slot="activator" v-if="activeStatus === 'pending'">
                  Pendente
                </v-list-tile-action-text>
                <span>{{ payment_slip.last_viewed_at | formatDateTime }}</span>
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card>

      <v-layout
        v-if="totalPages"
        justify-center
        align-center
      >
        <v-pagination class="align-self-center"
          color="teal darken-4"
          v-model="activePage"
          :length="totalPages"
          total-visible="5"
          circle
        />
      </v-layout>
    </v-layout>

    <v-card v-if="!payment_slips.length">
      <v-card-text>
        <v-layout class="empty-list" justify-center align-center column>
          <img
            class="mb-3 icon"
            src="@/assets/image/icon/leaf.svg"
            alt="Ícone Ambiental"
            width="320"
          />
          <h1 class="heading">Não há boletos para exibir</h1>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
export default {
  name: "PaymentSlipsList",
  props: {
    activeStatus: {
      type: String,
      default: ""
    },
    payment_slips: {
      default: () => [],
      type: Array
    },
    totalPages: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    totalItems: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      activePage: this.page,
    }
  },
  methods: {
    showApplication(payment_slip) {
      this.$store.dispatch("setLoadingDialog", true);
      this.$router.push(`${payment_slip.id}/visualizar`);
    },
    personalTypeIcon(payment_slip) {
      return payment_slip.person.person_type === "physical_person" ? "mdi-account" : "mdi-domain";
    }
  },
  watch: {
    activePage() {
      this.$emit('changePage', this.activePage);
    }
  }
};
</script>
